import { Component, Prop, Watch } from 'vue-property-decorator';
import { LocationDTO } from '../../../model/LocationDTO';
import { LocationStatsDTO } from '../../../model/LocationStatsDTO';
import { Block } from '../../../helpers/components';
import { BaseBlock } from '../../base-block';
import { CountUp } from "@/components/count-up/count-up";

@Block() @Component({
	components: {
		CountUp
	}
})
export class ApartmentLocationCountUpBlock extends BaseBlock {
	@Prop() location: LocationDTO;
	@Prop() locationStats: LocationStatsDTO;

	startVal: number[] = this.getText('start').split(';').map(Number);
	countItems: number = parseInt(this.getText('count-items'));
	
	get endVal() {
		return this.addElementForFreeApartment('end', this.locationStats.availableCompletedApartmentCount + this.locationStats.availableNotCompletedApartmentCount, Number);
	}

	get description() {
		return this.addElementForFreeApartment('description', this.descriptionFreeAparment());
	}

	get sufix() {
		return this.addElementForFreeApartment('sufix');
	}

	addElementForFreeApartment(item: string, element: any = null, type: any = null) {
		let a = this.getText(item).split(';')
		if (type === Number) {
			a.map(Number);
		}
		a.unshift(element);
		return a;
	}
	
	descriptionFreeAparment() {
		const resource = this.getText('free-apartment').split(';');
		const freeApartments = this.locationStats.availableCompletedApartmentCount + this.locationStats.availableNotCompletedApartmentCount;
		
		switch (true) {
			case (freeApartments == 1):
				return resource[0];
				break;
			case (freeApartments >= 2 && freeApartments <= 4):
				return resource[1];
				break;
			case (freeApartments >= 5):
				return resource[2];
				break;
			default:
				return resource[2];
		}
	}
}

export default ApartmentLocationCountUpBlock;
